import React, { FunctionComponent } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import AuthProvider from './auth';

const theme = createTheme();

type AppContextProps = {
  children: React.ReactNode;
}

const AppContext: FunctionComponent<AppContextProps> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        { children }
      </AuthProvider>
    </ThemeProvider>
  );
}

export default AppContext;
